<template>
	<div class="webContent flex">
		<div class="model">
			<div class="search df hao">
				<input type="text" puc class="flex" placeholder="本版块搜索" v-model="keyword" />
				<div class="btn" @click="search"></div>
			</div>
			<div class="scroll" @scroll="listenScroll">
				<div class="list">
					<div class="li" v-for="(v,i) in list" @click="toDetail(v)">
						<div class="title"><i v-if="v.announcement==1" class="rule"></i><i v-if="v.refining==1" class="prize"></i><i v-if="v.top==1" class="top"></i><div v-html="v.title">{{v.title}}</div></div>
						<div class="tool df">
							<div class="flex">{{v.answerTotal>0?v.answerTotal+'人回答':'暂无回答'}} · {{v.attentionTotal>0?v.attentionTotal+'人关注':'暂无关注'}}</div>
							<div><b>{{v.creatorName||''}}</b>{{dateTime(v.createTime)}}</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'home_search_page',
		data () {
			return {
				keyword: '',
				pagenum: 1,
				pagesize: 10,
				state: false,
				list: [],
			}
		},
		mounted(){
			this.keyword = this.$route.query.keyword;

			this.getList();
		},
		methods: {
			dateTime(timestamp){
				if(!timestamp){ return ''; }
				var date = new Date(timestamp);
				var year = date.getFullYear();
				var month = date.getMonth()+1;
				var day = date.getDate();
				month = (month<10?'0':'')+month;
				day = (day<10?'0':'')+day;
				return year+'-'+month+'-'+day;
			},
			listenScroll(e) {  //监听滚动
				let ele = e.srcElement ? e.srcElement : e.target;
				if(ele.scrollTop + ele.offsetHeight > ele.scrollHeight - 100){
					this.addMoreData();
				}
			},
			addMoreData() { //加载更多
				if(this.state){
					return false;
				}
				this.pagenum ++;
				this.getList();
			},
			search(){
				this.pagenum = 1;
				this.state = false;
				this.list = [];
				this.getList();
			},
			getList(){
				this.state = true;

				// 获取分类列表版块信息
				this.h5Ajax('get','$/questions/searchListPage',{
					keyword: this.keyword,
					page: this.pagenum,
					categoryId: '',
					size: this.pagesize,
				}).then(r=>{
					if(r.content.length>0){
						for(var i in r.content){
							var d = r.content[i];
							this.list.push(d)
						}
						this.state = false;
					}
				}).catch(err => {
					console.error('err:' + err)
				})
			},
			toDetail(data){
				this.$router.replace({ path: '/topic/detail', query: { id: data.id } });
			},
		},
	}
</script>

<style scoped>
	@import './search'
</style>



// WEBPACK FOOTER //
// src/app/pages/home/search/search.vue